// TODO: Write tests for this file

import React from "react";

import { DOCS_ID } from "./constants";
import { styles } from "./styles";

export const FederatedModulesDocsHelmet: React.FC = () => {
  const refOfOriginalBodyClassName = React.useRef<string | undefined>();

  React.useEffect(() => {
    // On mount, sets necessary class on the body tag.
    // On unmount, removes it.

    refOfOriginalBodyClassName.current = document.body.className;
    document.body.className = DOCS_ID;

    return () => {
      if (refOfOriginalBodyClassName.current) {
        document.body.className = refOfOriginalBodyClassName.current;
      }
    };
  }, []);

  React.useEffect(() => {
    // On mount, sets necessary styles in the head.
    // On unmount, removes them.

    const styleElem = document.createElement("style");
    document.head.appendChild(styleElem);
    styleElem.appendChild(document.createTextNode(styles));

    return () => {
      document.head.removeChild(styleElem);
    };
  });

  return null;
};
